import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Text from '../Text';

function Link(_ref) {
  var to = _ref.to,
      external = _ref.external,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'primary' : _ref$color,
      _ref$underline = _ref.underline,
      underline = _ref$underline === void 0 ? true : _ref$underline,
      hover = _ref.hover,
      focus = _ref.focus,
      restProps = _objectWithoutPropertiesLoose(_ref, ["to", "external", "color", "underline", "hover", "focus"]);

  var props = {
    display: 'inline-block',
    position: 'relative',
    hover: _objectSpread({
      color: color
    }, hover),
    focus: _objectSpread({
      color: color
    }, focus),
    color: color
  };

  if (restProps.disabled) {
    props.cursor = 'not-allowed';
    props.opacity = 0.64;
  } else {
    props.cursor = 'pointer';

    if (to) {
      props.as = 'a';
      props.href = to;
    }

    if (external) {
      props.rel = 'noopener noreferrer';
      props.target = '_blank';
    }

    if (underline) {
      props.hover = _objectSpread({
        color: color,
        textDecoration: 'underline'
      }, hover);
      props.focus = _objectSpread({
        color: color,
        textDecoration: 'underline'
      }, focus);
    }
  }

  return /*#__PURE__*/React.createElement(Text, _extends({}, props, restProps));
}

export default Link;